<template>
  <div class="map">
    <template v-for="(area, i) in data.areas">
      <MapArea
        :key="i"
        :data="area"
      />
    </template>
  </div>
</template>

<script>
export default {
  props: {
    data: {type: Object, required: true},
  },
}
</script>

<style scoped lang="scss">
.map {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>
